import { variant } from 'styled-system'
import colors from '../../constants/colors'
import { ButtonProps } from './Button.types'

const buttonVariant = variant({
  prop: 'variant',
  variants: {
    primary: {
      backgroundColor: colors.blue50,
      color: colors.white,
      border: 'none',
      borderRadius: '8px',
      '&:hover': {
        backgroundColor: colors.blue75,
      },
      '&:disabled': {
        backgroundColor: colors.black10,
        cursor: 'not-allowed',
        color: colors.black25,
      },
      '&:active': {
        backgroundColor: colors.blue100,
      },
      svg: {
        path: {
          fill: colors.white,
        },
      },
    },
    secondary: {
      backgroundColor: colors.blue5,
      color: colors.blue50,
      border: 'none',
      borderRadius: '8px',
      svg: {
        path: {
          fill: colors.blue50,
        },
      },
      '&:hover': {
        backgroundColor: colors.blue10,
        color: colors.blue25,
        svg: {
          path: {
            fill: colors.blue25,
          },
        },
      },
      '&:disabled': {
        backgroundColor: colors.black5,
        color: colors.black10,
        cursor: 'not-allowed',
        svg: {
          path: {
            fill: colors.black10,
          },
        },
      },
      '&:active': {
        backgroundColor: colors.blue25,
        color: colors.white,
        svg: {
          path: {
            fill: colors.white,
          },
        },
      },
    },
    tertiary: {
      backgroundColor: colors.white,
      color: colors.black75,
      border: `solid 1px ${colors.black10}`,
      borderRadius: '8px',
      svg: {
        path: {
          fill: colors.black75,
        },
      },
      '&:hover': {
        backgroundColor: colors.white,
        color: colors.black100,
        svg: {
          path: {
            fill: colors.black100,
          },
        },
      },
      '&:disabled': {
        backgroundColor: colors.white,
        border: `solid 1px ${colors.black5}`,
        color: colors.black25,
        cursor: 'not-allowed',
        svg: {
          path: {
            fill: colors.black5,
          },
        },
      },
      '&:active': {
        backgroundColor: colors.white,
        border: `solid 1px ${colors.black50}`,
        color: colors.black100,
        svg: {
          path: {
            fill: colors.black100,
          },
        },
      },
    },
    circular: {
      backgroundColor: colors.white,
      borderRadius: '9999px',
      border: 'none',
      '&:disabled': {
        backgroundColor: colors.black10,
        svg: {
          path: {
            fill: colors.white,
          },
        },
      },
    },
  },
})

const buttonSize = (props: ButtonProps) =>
  variant({
    prop: 'size',
    variants: {
      large: {
        fontWeight: '700',
        padding:
          props.variant === 'circular'
            ? '10px'
            : props.icon
            ? '12px'
            : props.suffix
            ? '12px 8px 12px 16px'
            : '12px 24px',
        fontSize: '14px',
        lineHeight: '24px',
      },
      medium: {
        fontWeight: '700',
        padding:
          props.variant === 'circular'
            ? '8px'
            : props.icon
            ? '12px'
            : props.suffix
            ? '12px 8px 12px 16px'
            : '8px 24px',
        fontSize: '14px',
        lineHeight: '24px',
      },
      small: {
        fontWeight: '700',
        padding:
          props.variant === 'circular'
            ? '5px'
            : props.icon
            ? '10px'
            : props.suffix
            ? '12px 8px 12px 16px'
            : '6px 16px',
        fontSize: '12px',
        lineHeight: '20px',
      },
    },
  })

export { buttonVariant, buttonSize }
